import React from 'react'

export default function useOnHashChange (callback, dependencies = []) {
  const handleOnPopstate = (state) => {
    if (typeof callback === 'function') {
      callback(state)
    }
  }

  React.useEffect(() => {
    window.addEventListener('hashchange', handleOnPopstate)

    return () => {
      window.removeEventListener('hashchange', handleOnPopstate)
    }
  }, dependencies)
}
